export const apiFlags = [
    {
        status: true,
        value: 'jd~he'
    },
    {
        status: true,
        value: 'jd~en'
    },
    {
        status: true,
        value: 'company_name'
    },
    {
        status: false,
        value: 'drushim_category_id~en'
    },
    {
        status: false,
        value: 'drushim_category_id~en~he'
    }
];